
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-search-line',
      title: 'SEO Optimization',
      description:
        'Dominate search engine rankings with our proven SEO strategies. We help your business appear at the top of Google search results, driving organic traffic and qualified leads.',
      features: ['Keyword Research', 'On-Page SEO', 'Link Building', 'Local SEO'],
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Digital Marketing',
      description:
        'Comprehensive digital marketing campaigns that convert. From social media to PPC advertising, we create strategies that maximize your ROI and grow your business.',
      features: ['Social Media Marketing', 'PPC Campaigns', 'Content Marketing', 'Email Marketing'],
    },
    {
      icon: 'ri-global-line',
      title: 'Web Development',
      description:
        'Build powerful, responsive websites that engage visitors and drive conversions. Our development team creates custom solutions tailored to your business needs.',
      features: ['Custom Websites', 'E-commerce Solutions', 'Mobile Optimization', 'CMS Integration'],
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Analytics & Reporting',
      description:
        'Data-driven insights that inform your business decisions. Track performance, understand your audience, and optimize your digital presence with detailed analytics.',
      features: ['Performance Tracking', 'Custom Reports', 'Conversion Analysis', 'ROI Measurement'],
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Brand Strategy',
      description:
        'Build a powerful brand that resonates with your target audience. We develop comprehensive brand strategies that differentiate you from competitors.',
      features: ['Brand Identity', 'Market Positioning', 'Competitive Analysis', 'Brand Guidelines'],
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Consulting Services',
      description:
        'Expert guidance for your digital transformation journey. Our consultants provide strategic advice to help you navigate the complex digital landscape.',
      features: ['Strategy Development', 'Technology Consulting', 'Process Optimization', 'Training'],
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Products & Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive digital solutions designed to help your business thrive in the modern
            marketplace. We combine expertise, innovation, and proven strategies to deliver
            exceptional results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 border border-gray-200 hover:border-orange-500 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-orange-600 transition-colors">
                <i
                  className={`${service.icon} text-2xl text-orange-600 group-hover:text-white transition-colors`}
                ></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-orange-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="mailto:domination@thompsondigital.org"
            className="inline-block px-8 py-4 bg-orange-600 text-white text-base font-semibold rounded-lg hover:bg-orange-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Request a Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
